export const MODE_TYPE = {
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX'
}

export const VIEW_TYPE = {
    DEFAULT: 'DEFAULT',
    GROUPED: 'GROUPED',
}
